import type { FaireProductEntity } from "../../entity_types/product";

export const p_rmhxumw3mq: FaireProductEntity = {
  token: "p_rmhxumw3mq",
  type: "product",
  name: "Yarn Slut Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/5b6269c03a30d1fdf480e7d12c38a4501c4588f0b1650b04a548e1c275f404b1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5c056971ad3ab11eff42190c52ec0e0e8707279c9b36df9833486fa6fc902626.jpeg",
    "https://cdn.faire.com/fastly/34f4ea2166519ee9804464830ec1bb9522f2d6340190e25fffae35d7de8bdf80.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/3086da638eeb6858570c466fcf3a6da0091c0fa7799c583bbae696972103c18d.jpeg",
    "https://cdn.faire.com/fastly/94b8e1043e7a5c02efc5470a54beb808a1603c6fb2e45fc1124ac47de2d7488d.jpeg"
  ],
  priceDollars: 6.75,
  description: "These socks are for you folks that know a thing or two about tension (and tiny pairs of scissors). May these be the only socks you don't knit yourself. 💕🧦\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:52.054Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
